import { render, staticRenderFns } from "./RoleCadastro.vue?vue&type=template&id=62753523&scoped=true&lang=html"
import script from "./RoleCadastro.vue?vue&type=script&lang=js"
export * from "./RoleCadastro.vue?vue&type=script&lang=js"
import style0 from "./RoleCadastro.vue?vue&type=style&index=0&id=62753523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62753523",
  null
  
)

export default component.exports